<template>
  <div class="hover">
    <div v-if="data.column.field == 'resourceName'" class="resource-cell__wrapper--first">
      <span>
        {{ data.row.item[0].resourceName }}
      </span>
    </div>
    <template v-for="resourceObj in data.row.item">
      <div
        v-if="data.column.field == resourceObj.languageId"
        :key="resourceObj.id"
        class="resource-wrap"
      >
        <div
          v-if="isEditing && editingResourceActive"
          class="d-flex justify-content-between align-items-center"
        >
          <b-form-input
            v-model="temporaryResourceValue"
            size="sm"
            type="text"
            autofocus
            @blur="closeEdit"
          />
          <b-button
            size="sm"
            variant="link-secondary"
            @mousedown="save(resourceObj)"
          >
            <GjIcon
              :key="`check-${data.row.id}`"
              name="Check"
            />
          </b-button>
          <b-button
            size="sm"
            variant="link-secondary"
            @mousedown="closeEdit"
          >
            <GjIcon
              :key="`close-${data.row.id}`"
              name="Close"
            />
          </b-button>
        </div>
        <div
          v-else
          class="d-flex justify-content-between resource-cell"
        >
          <span class="eclipsis resource-cell__span--height">
            {{ resourceObj.resourceValue || " - " }}
          </span>
          <b-button
            class="px-0 hover-visible"
            variant="link"
            @click="openEdit(resourceObj)"
          >
            <GjIcon
              :key="`edit-${data.row.id}`"
              class="text-secondary"
              name="Edit"
            />
          </b-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  ref, computed,
} from '@vue/composition-api'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import store from '@/store'
import LanguagesService from '@/api/admin/languages.service'
import notification from '@/mixins/toastification'

export default {
  components: {
    GjIcon,
  },
  props: {
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const isEditing = ref(false)
    const editingResourceActive = computed(() => store.getters.isEditingResource)
    const temporaryResourceValue = ref('')
    const openEdit = resourceObj => {
      if (!editingResourceActive.value) {
        store.commit('SET_EDITING_RESOURCE', true)
        isEditing.value = !isEditing.value
      }
      temporaryResourceValue.value = resourceObj.resourceValue
    }

    const closeEdit = () => {
      if (isEditing.value) {
        isEditing.value = false
        if (editingResourceActive.value) {
          store.commit('SET_EDITING_RESOURCE', false)
        }
      }
    }
    const save = async resourceObj => {
      resourceObj.resourceValue = temporaryResourceValue.value
      try {
        const response = await LanguagesService.updateLanguageResource(resourceObj)
        if (response.success) {
          notification.methods.success(response.message)
        } else {
          notification.methods.error(response.message)
        }
      } catch (err) {
        notification.methods.error(err.message)
      } finally {
        closeEdit()
      }
    }
    return {
      isEditing,
      openEdit,
      editingResourceActive,
      closeEdit,
      temporaryResourceValue,
      save,
    }
  },
}
</script>
<style lang="scss">
  @import '@/assets/scss/views/admin/configuration/table-translations.scss';
</style>
